"use client";

import FilterGroup from "./FilterGroup";

export default function FilterSidebar({
  open,
  onClose,
  departmentSlug,
  department,
  categoryNames,
  selectedCategory,
  onCategoryChange,
  brands,
  brandCounts,
  selectedBrands,
  onBrandToggle,
  maxPrice,
  onMaxPriceChange,

  dynamicValues,
  selectedOptions,
  onOptionToggle,

  stockOnly,
  onStockChange,

  saleOnly,
  onSaleChange,

  onClear,
}) {
  return (
    <aside
      className={`asian-bucket-filter-sidebar-main-wrapper ${
        open ? "is-open" : ""
      }`}
    >
      {/* HEADER */}

      <div className="asian-bucket-filter-sidebar-heading">
        <strong>Filters</strong>

        <button
          type="button"
          className="asian-bucket-filter-clear-all-button"
          onClick={onClear}
        >
          Clear All
        </button>

        <button
          type="button"
          className="asian-bucket-filter-mobile-close-button"
          onClick={onClose}
          aria-label="Close filters"
        >
          ×
        </button>
      </div>

      {/* CATEGORY */}

      <FilterGroup title="Category">
        <nav className="asian-bucket-filter-category-list">
          {categoryNames.map((category) => (
            <button
              key={category}
              type="button"
              className={selectedCategory === category ? "is-active" : ""}
              onClick={() => onCategoryChange(category)}
            >
              {category}
            </button>
          ))}
        </nav>
      </FilterGroup>

      {/* BRAND */}

      {!!brands.length && (
        <FilterGroup title="Brand">
          <div className="asian-bucket-filter-checkbox-list">
            {brands.map((brand) => (
              <label key={brand}>
                <input
                  type="checkbox"
                  checked={selectedBrands.includes(brand)}
                  onChange={() => onBrandToggle(brand)}
                />

                <span>
                  {brand}

                  {brandCounts[brand] ? ` (${brandCounts[brand]})` : ""}
                </span>
              </label>
            ))}
          </div>
        </FilterGroup>
      )}

      {/* PRICE */}

      <FilterGroup title="Price">
        <label className="asian-bucket-price-filter">
          <span>Maximum price</span>

          <input
            type="number"
            min="0"
            step="1"
            value={maxPrice}
            onChange={(event) => onMaxPriceChange(event.target.value)}
            placeholder="No limit"
          />
        </label>
      </FilterGroup>

      {/* DYNAMIC FILTERS */}

      {department.filters
        .filter(
          (filter) => !["brand", "price", "availability"].includes(filter.key),
        )
        .map((filter) => {
          const options =
            filter.type === "dynamic"
              ? dynamicValues[filter.key] || []
              : filter.options || [];

          if (!options.length) {
            return null;
          }

          return (
            <FilterGroup key={filter.key} title={filter.label}>
              <div className="asian-bucket-filter-checkbox-list">
                {options.map((value) => (
                  <label key={value}>
                    <input
                      type="checkbox"
                      checked={(selectedOptions[filter.key] || []).includes(
                        value,
                      )}
                      onChange={() => onOptionToggle(filter.key, value)}
                    />

                    <span>{value}</span>
                  </label>
                ))}
              </div>
            </FilterGroup>
          );
        })}

      {/* AVAILABILITY */}

      <FilterGroup title="Availability">
        <div className="asian-bucket-filter-checkbox-list">
          <label>
            <input
              type="checkbox"
              checked={stockOnly}
              onChange={(event) => onStockChange(event.target.checked)}
            />

            <span>
              {departmentSlug === "take-out" ? "Available Now" : "In Stock"}
            </span>
          </label>

          {departmentSlug !== "take-out" && (
            <label>
              <input
                type="checkbox"
                checked={saleOnly}
                onChange={(event) => onSaleChange(event.target.checked)}
              />

              <span>On Sale</span>
            </label>
          )}
        </div>
      </FilterGroup>
    </aside>
  );
}
